import { AppRoute } from 'v2/routes';
import { FormButton, FormReward } from 'v2/types';

export enum UserRole {
  DEFAULT_USER = 'DEFAULT_USER',
  STREAMER = 'STREAMER',
  MODERATOR = 'MODERATOR',
  ADMIN = 'ADMIN',
  SELLS_ADMIN = 'SELLS_ADMIN',
  SUPPORT_ADMIN = 'SUPPORT_ADMIN',
  SUPPORT = 'SUPPORT',
}

export enum Locale {
  ru_RU = 'ru-RU',
  en_US = 'en-US',
  kk_KZ = 'kk-KZ',
}

export enum LocalStorageKey {
  LOCALE = 'locale',
  GEO = 'geo',
}

export enum Geo {
  RU = 'ru',
  KZ = 'kz',
}

export const geoToUIMap: Record<Geo, { label: string; color: 'info' | 'warning' }> = {
  [Geo.RU]: { label: 'RU', color: 'info' },
  [Geo.KZ]: { label: 'KZ', color: 'warning' },
};

export enum UserGuideType {
  INTRO = 'INTRO',
}

export enum UserRewardType {
  BONUS = 'BONUS',
  BALANCE = 'BALANCE',
  DIAMONDS = 'DIAMONDS',
  MACBOOK = 'MACBOOK',
  IPHONE = 'IPHONE',
  MONEY = 'MONEY',
  PROMO_CODE = 'PROMOCODE',
  LEVEL = 'LEVEL',
  NO_REWARD = 'NO_REWARD',
  SPECIAL_TICKET = 'SPECIAL_TICKET',
  FREE_SPINS = 'FREESPINS',
  PLAYSTATION = 'PLAYSTATION',
  PIXEL = 'PIXEL',
  YANDEX_STATION = 'YANDEX_STATION',
  RS_CAP = 'RS_CAP',
  WB_CERTIFICATE = 'WB_CERTIFICATE',
  CRYPTOCHECK = 'CRYPTOCHECK',
  REFERRAL_MONEY = 'REFERRAL_MONEY',
  REFERRAL_SPIN = 'REFERRAL_SPIN',
  WELCOME_PACK = 'WELCOME_PACK',
  GOLDEN_TICKET = 'GOLDEN_TICKET',
  CONTEST_TICKET = 'CONTEST_TICKET',
}

export enum TournamentRewardType {
  BALANCE = 'BALANCE',
  DEFAULT_CONTEST_TICKET = 'DEFAULT_CONTEST_TICKET',
  CUSTOM = 'CUSTOM',
}

export enum ProviderName {
  BELATRA = 'BELATRA',
  BGAMING = 'BGAMING',
  ENDORPHINA = 'ENDORPHINA',
  ONLYPLAY = 'ONLYPLAY',
  AMATIC = 'AMATIC',
  EVOPLAY = 'EVOPLAY',
  MASCOT = 'MASCOT',
  GAMEBEAT = 'GAMEBEAT',
  POPIPLAY = 'POPIPLAY',
  GAMZIX = 'GAMZIX',
  IGROSOFT = 'IGROSOFT',
  JDB = 'JDB',
  TRUELAB = 'TRUELAB',
  ONESPIN4WIN = '1SPIN4WIN',
  FUGASO = 'FUGASO',
  NOBLES_GAMING = 'NOBLESGAMING',
  DYNABIT = 'DYNABIT',
  AVIATRIX = 'AVIATRIX',
}

export enum EvoplayFreeSpinsType {
  BONUS_SPINS = 'bonus_spins',
  FREESPINS_ON_START = 'freespins_on_start',
}

export enum DailyTaskType {
  X = 'HIT_X',
  SUM_X = 'SUM_X',
  COUNT_HIT_X = 'COUNT_HIT_X',
  SPECIFIC_X = 'SPECIFIC_X',
  TOP_X = 'TOP_X',
}

export enum SpecialTaskType {
  TASKS = 'TASKS',
  REFERRALS = 'REFERRALS',
  PASSWORD = 'PASSWORD',
  GOLDEN_TICKET = 'GOLDEN_TICKET',
}

export enum VideoCategory {
  WEEK = 'WEEK',
  TREPUTIN = 'TREPUTIN',
  LUI = 'LUI',
  NEW = 'NEW',
}

export enum PromoCodeType {
  BALANCE = 'BALANCE',
  FREE_SPINS = 'FREESPINS',
  REFERRAL_SPIN = 'REFERRAL_SPIN',
  DIAMOND = 'DIAMOND',
  GOLDEN_TICKET = 'GOLDEN_TICKET',
  CONTEST_TICKET = 'CONTEST_TICKET',
}

export enum TicketStatus {
  USED = 'USED',
  EXPIRED = 'EXPIRED',
  AVAILABLE = 'AVAILABLE',
  NOT_ACTIVE = 'NOT_ACTIVE',
}

export enum TicketType {
  GOLDEN = 'GOLDEN',
  CONTEST = 'CONTEST',
}

export enum StoreProductType {
  BALANCE = 'BALANCE',
  STREAM_BONUS = 'STREAM_BONUS',
  PROMOCODE = 'PROMOCODE',
  TECHNIC = 'TECHNIC',
  MERCH = 'MERCH',
  FS = 'FS',
  CERTIFICATE = 'CERTIFICATE',
  GOLDEN_TICKET = 'GOLDEN_TICKET',
}

export enum SlotMark {
  POPULAR = 'POPULAR',
  NEW = 'NEW',
  TASK = 'TASK',
  HOT = 'HOT',
  HALLOWEEN = 'HALLOWEEN',
  NEW_YEAR = 'NEW_YEAR',
  PROVIDERS_POPULAR = 'PROVIDERS_POPULAR',
}

export enum EntryRewardStatus {
  CREATED = 'CREATED',
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
}

export enum BoxDistributionType {
  TOP = 'top',
  RANDOM = 'random',
}

export enum ABTestEntity {
  AD_BANNER = 'AD_BANNER',
  USER_GUIDE = 'USER_GUIDE',
}

export enum PromotionStatus {
  PLATINUM = 'platinum',
  GOLD = 'gold',
  SILVER = 'silver',
  BRONZE = 'bronze',
  NO_STATUS = 'no-status',
}

export enum BalanceJobType {
  BY_LEVEL = 'BY_LEVEL',
  BY_DEFAULT = 'BY_DEFAULT',
}

export enum PromotionType {
  DEPOSIT = 'deposit',
  REGISTRATION = 'registration',
}

export enum LotteryType {
  USER_ID = 'USER_ID',
  EMAIL = 'EMAIL',
}

export enum CasinoBonusMarksEnum {
  NEW = 'NEW',
  REGISTRATION = 'REGISTRATION',
  DEPOSIT = 'DEPOSIT',
  NON_DEPOSIT = 'NON_DEPOSIT',
}

export const WRITE_GROUP = [UserRole.ADMIN, UserRole.MODERATOR];
export const MANAGEMENT_GROUP = [UserRole.ADMIN];
export const SELLS_GROUP = [UserRole.ADMIN, UserRole.SELLS_ADMIN];
export const HEAD_SUPPORT_GROUP = [UserRole.ADMIN, UserRole.MODERATOR, UserRole.SUPPORT_ADMIN];
export const SERVICE_GROUP = [UserRole.ADMIN, UserRole.MODERATOR, UserRole.SUPPORT_ADMIN, UserRole.SELLS_ADMIN];
export const SUPPORT_GROUP = [UserRole.ADMIN, UserRole.MODERATOR, UserRole.SUPPORT_ADMIN, UserRole.SUPPORT];

export const STREAMER_WHEEL = 'contest_wheel';

export const userRoleToUIMap: Record<UserRole, string> = {
  [UserRole.DEFAULT_USER]: 'User',
  [UserRole.STREAMER]: 'Streamer',
  [UserRole.MODERATOR]: 'Moderator',
  [UserRole.ADMIN]: 'Administrator',
  [UserRole.SELLS_ADMIN]: 'Sales',
  [UserRole.SUPPORT_ADMIN]: 'Head Support',
  [UserRole.SUPPORT]: 'Support',
};

export const REWARD_STUB: FormReward = {
  value: '',
  count: 1,
  type: UserRewardType.BALANCE,
};

export const BUTTON_STUB: FormButton = {
  name: '',
  link: '',
};

export const USER_ROLES = Object.values(UserRole);

export const DESKTOP_VIEW = 768;

export const DEFAULT_FIRST_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 20;

export const LONG_DASH = '—';

export const SELECT_NONE_OPTION = { id: '', value: '', label: 'None' };

export enum PartnerSpotlightStatusesEnum {
  GOLD = 'GOLD',
  SILVER = 'SILVER',
  BRONZE = 'BRONZE',
}

export const GEO_AFFECTED_ROUTES: AppRoute[] = [
  AppRoute.CASINO_SETTINGS_PAGE,
  AppRoute.CASINO_ADS_SETTINGS_PAGE,
  AppRoute.DOMAIN_SETTINGS_PAGE,
  AppRoute.LOTTERY_SETTINGS,
  AppRoute.STREAMER_WHEEL_SETTINGS_PAGE,
  AppRoute.BROADCAST_NOTIFICATIONS_PAGE,
  AppRoute.MODAL_SETTINGS_PAGE,
];
